import { Policies } from 'src/app/core/policy/policy';
import { CTE_PROJECTS } from 'src/app/core/services/coockies.user';
import { IconsPng } from 'src/app/wap/configuration/shared/models/icons.model';
import { getPngImage } from 'src/app/wap/configuration/shared/services/shared.service';
import { RouteAppGroup } from '../route.model';
import { RoutesShortWandP, TextMenu } from './routes.enum';
import { SUPER_ADMIN } from 'src/app/core/policy/roles';

export const SERVER_ROUTE = 'wap/';
// ----------------------------------------------------- Routes ------------------------------------------------------------------
// Default route where the user is redirected when login
export const DEFAULT_ROUTE_APP = `${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.Punches}`;
export const DEFAULT_NO_PROJECTS = `${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.Templates}/${RoutesShortWandP.TemplatesGlobalCollections}`;

export const ROUTE_INSPECTIONS = `${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.Inspections}`;
export const ROUTE_INSPECTIONS_DETAIL_NEW = `${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.Inspections}/${RoutesShortWandP.Detail}/${RoutesShortWandP.New}`;
export const ROUTE_INSPECTIONS_DETAIL = `${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.Inspections}/${RoutesShortWandP.Detail}/`;

export const ROUTE_FULL_COLLECTIONS_GLOBAL = `${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.Templates}/${RoutesShortWandP.TemplatesGlobalCollections}`;
export const ROUTE_FULL_COLLECTIONS_PROJECT = `${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.Templates}/${RoutesShortWandP.TemplatesProjectCollections}`;
export const ROUTE_FULL_DETAIL_TEMPLATE_GLOBAL =
  `/${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.Templates}/${RoutesShortWandP.TemplatesGlobal}/`;
export const ROUTE_FULL_DETAIL_TEMPLATE_PROJECT =
  `/${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.Templates}/${RoutesShortWandP.TemplatesDetail}/`;
export const ROUTE_SHORT_DETAIL_TEMPLATE = RoutesShortWandP.TemplatesDetail;
export const ROUTE_SHORT_COLLECTION_PROJECT_TEMPLATE = RoutesShortWandP.TemplatesProjectCollections;

export const ROUTE_REPORTS = `${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.Reports}`;
export const ROUTE_REPORTS_DETAIL = `${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.Reports}/${RoutesShortWandP.Detail}/`;

export const ROUTE_LIVE_REPORTS_NEW = `${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.LiveReports}/${RoutesShortWandP.Detail}`;
export const ROUTE_SIGN_PUNCHES = `${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.SignedPunches}`;
export const ROUTE_SIGN_PUNCHES_REVIEW = `${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.SignedPunches}/${RoutesShortWandP.Detail}`;
export const ROUTE_SIGN_PUNCHES_UPDATE = `${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.SignedPunches}/${RoutesShortWandP.Update}`;
export const ROUTE_INSPTECTION_TYPES = `${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.TemplateConfiguration}/${RoutesShortWandP.InspectionTypes}`;
export const TEMPLATE_OVERVIEW = `${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.TemplateConfiguration}/${RoutesShortWandP.TemplateOverview}`;
export const PROJECT_OVERVIEW = `${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.ProjectSetup}/${RoutesShortWandP.ProjectOverview}`;
// ----------------------------------------------------- Routes ------------------------------------------------------------------

// --------------------------------------------------- Query Params ----------------------------
export const ROUTE_LOGIN_QUERY_PARAMS_NOPROJECTS = 'noProjects';


// ------------------------------------------------- Configuration Menu ----------------------------------------------------------
export const MAIN_ROUTES: RouteAppGroup = {
  name: TextMenu.Main,
  conditionToShow: () => checkProjects(),
  routes: [
    {
      id: TextMenu.Inspections, name: TextMenu.Inspections, img: getPngImage(IconsPng.inspection), path: RoutesShortWandP.Inspections,
      conditionToShow: () => checkProjects(), policies: [Policies.InspectionsView]
    },
    {
      id: TextMenu.Punches, name: TextMenu.Punches, img: getPngImage(IconsPng.punches), path: RoutesShortWandP.Punches,
      conditionToShow: () => checkProjects(), policies: [Policies.PunchesView]
    },
    {
      id: TextMenu.Reports, name: TextMenu.Reports, img: getPngImage(IconsPng.documents), path: RoutesShortWandP.Reports,
      conditionToShow: () => checkProjects(), policies: [Policies.BiReportsView]
    },
    {
      id: TextMenu.Downloads, name: TextMenu.Downloads, img: getPngImage(IconsPng.downloads), path: `${RoutesShortWandP.Common}/${RoutesShortWandP.Downloads}`,
      conditionToShow: () => checkProjects(), policies: [Policies.WapReportsView]
    },
    {
      id: TextMenu.SignedPunches, name: TextMenu.SignedPunches, img: getPngImage(IconsPng.items), path: RoutesShortWandP.SignedPunches,
      conditionToShow: () => checkProjects()
    },
  ]
};

export const SECOND_MENU_ROUTER: RouteAppGroup[] = [
  {
    name: TextMenu.WP_Administration,
    // conditionToShow: () => checkProjects(),
    conditionToShow: () => true,
    routes: [
      { // Old Admin
        id: TextMenu.MasterTables, name: TextMenu.MasterTables, path: RoutesShortWandP.MasterTables,
        img: getPngImage(IconsPng.masterTables), policies: [Policies.MasterTablesView],
        conditionToShow: () => true
      },
      { // Old Admin
        id: TextMenu.Projects, name: TextMenu.Projects, path: RoutesShortWandP.Projects,
        img: getPngImage(IconsPng.projects), policies: [Policies.ProjectsView],
        conditionToShow: () => true
      },
      { // Old Admin
        id: TextMenu.Process, name: TextMenu.Process,
        path: `${RoutesShortWandP.Common}/${RoutesShortWandP.Process}`,
        img: getPngImage(IconsPng.process),
        conditionToShow: () => checkUserGlobalAdmin(), policies: [Policies.WapProcessView]
      },
      {
        id: TextMenu.UsersManagement, name: TextMenu.UsersManagement, img: getPngImage(IconsPng.users), path: RoutesShortWandP.Users,
        conditionToShow: () => checkUserGlobalAdmin(), policies: [Policies.MasterTablesView]
      },
      {
        id: TextMenu.Roles, name: TextMenu.Roles, path: RoutesShortWandP.Roles,
        img: getPngImage(IconsPng.inspection), policies: [Policies.RolesView],
        conditionToShow: () => true
      },
    ]
  },
  {
    name: TextMenu.ProjectSetup,
    conditionToShow: () => checkProjects(),
    routes: [
      {
        id: TextMenu.ProjectOverview, name: TextMenu.ProjectOverview,
        path: `${RoutesShortWandP.ProjectSetup}/${RoutesShortWandP.ProjectOverview}`,
        img: getPngImage(IconsPng.overview), policies: [Policies.TemplatesView],
        conditionToShow: () => checkProjects()
      },
      {
        id: TextMenu.ProjectSettings, name: TextMenu.ProjectSettings,
        path: `${RoutesShortWandP.ProjectSetup}/${RoutesShortWandP.ProjectSettings}`,
        img: getPngImage(IconsPng.config), policies: [Policies.TemplatesView],
        conditionToShow: () => checkProjects()
      },
      { // Old Admin Templates
        id: TextMenu.ProjectTemplates, name: TextMenu.ProjectTemplates,
        path: `${RoutesShortWandP.Templates}/${RoutesShortWandP.TemplatesProjectCollections}`,
        img: getPngImage(IconsPng.templates), policies: [Policies.TemplatesView],
        conditionToShow: () => checkProjects()
      },
      {
        id: TextMenu.WbsTree, name: TextMenu.WbsTree,
        path: `${RoutesShortWandP.ProjectSetup}/${RoutesShortWandP.WbsTree}`,
        img: getPngImage(IconsPng.hierarchy), policies: [Policies.TemplatesView],
        conditionToShow: () => checkProjects()
      },
      {
        id: TextMenu.ProjectProcess, name: TextMenu.ProjectProcess,
        path: `${RoutesShortWandP.Common}/${RoutesShortWandP.ProjectProcess}`,
        img: getPngImage(IconsPng.process),
        conditionToShow: () => checkProjects(), policies: [Policies.WapReportsView]
      },
      // {
      //   id: TextMenu.Configuration, name: TextMenu.Configuration,
      //   path: `${RoutesShortWandP.Templates}/${RoutesShortWandP.TemplatesDetail}`,
      //   img: getPngImage(IconsPng.config), policies: [Policies.ConfigurationView],
      //   conditionToShow: () => checkProjects()
      // },
      {
        id: TextMenu.Users, name: TextMenu.Users, path: RoutesShortWandP.UsersSetup,
        img: getPngImage(IconsPng.users), policies: [Policies.UsersView],
        conditionToShow: () => checkProjects()
      },
      {
        id: TextMenu.Maps, name: TextMenu.Maps, path: RoutesShortWandP.Maps,
        img: getPngImage(IconsPng.maps), policies: [Policies.MapsView],
        conditionToShow: () => checkProjects()
      },
      {
        id: TextMenu.Audit, name: TextMenu.Audit, path: RoutesShortWandP.Audit,
        img: getPngImage(IconsPng.masterTables), policies: [Policies.AuditView],
        conditionToShow: () => checkProjects()
      }
    ]
  },
  {
    name: TextMenu.TemplateConfiguration,
    conditionToShow: () => true,
    routes: [
      {
        id: TextMenu.TemplateOverview, name: TextMenu.TemplateOverview,
        path: `${RoutesShortWandP.TemplateConfiguration}/${RoutesShortWandP.TemplateOverview}`,
        img: getPngImage(IconsPng.overview), policies: [Policies.TemplatesView],
        conditionToShow: () => checkProjects()
      },
      {
        id: TextMenu.TemplateSettings, name: TextMenu.TemplateSettings,
        path: `${RoutesShortWandP.Templates}/${RoutesShortWandP.TemplatesGlobal}`,
        img: getPngImage(IconsPng.config), policies: [Policies.TemplatesView],
        conditionToShow: () => checkProjects()
      },
      {
        id: TextMenu.InspectionTypes, name: TextMenu.InspectionTypes,
        path: `${RoutesShortWandP.TemplateConfiguration}/${RoutesShortWandP.InspectionTypes}`,
        img: getPngImage(IconsPng.inspection), policies: [Policies.TemplatesView],
        conditionToShow: () => checkProjects()
      },
      {
        id: TextMenu.CustomFields, name: TextMenu.CustomFields,
        path: `${RoutesShortWandP.TemplateConfiguration}/${RoutesShortWandP.CustomFields}`,
        img: getPngImage(IconsPng.customFields), policies: [Policies.TemplatesView],
        conditionToShow: () => checkProjects()
      },
      // { // Old Admin
      //   id: TextMenu.Templates, name: TextMenu.Templates, 
      //   path: `${RoutesShortWandP.Templates}/${RoutesShortWandP.TemplatesGlobalCollections}`,
      //   img: getPngImage(IconsPng.templates), policies: [Policies.TemplatesView],
      //   conditionToShow: () => true
      // },
      { // Old Admin
        id: TextMenu.LiveReports, name: TextMenu.LiveReports,
        path: RoutesShortWandP.LiveReports,
        img: getPngImage(IconsPng.live_reports), policies: [Policies.LiveReports],
        conditionToShow: () => checkProjects()
      },
    ]
  },
  {
    name: TextMenu.Admin,
    conditionToShow: () => checkUserSuperAdmin(),
    routes: [
      // { // Old Admin
      //   id: TextMenu.Templates, name: TextMenu.Templates, 
      //   path: `${RoutesShortWandP.Templates}/${RoutesShortWandP.TemplatesGlobalCollections}`,
      //   img: getPngImage(IconsPng.templates), policies: [Policies.TemplatesView],
      //   conditionToShow: () => true
      // },
      {
        id: TextMenu.MaintenanceConfig, name: TextMenu.MaintenanceConfig,
        path: RoutesShortWandP.MaintenanceConfig, policies: [Policies.SuperAdmin],
        img: getPngImage(IconsPng.config),
        conditionToShow: () => checkUserSuperAdmin(),
      }
    ]
  }
];



export const LAST_ELEMENTS: RouteAppGroup = null;
// ------------------------------------------------- Configuration Menu ----------------------------------------------------------


// ------------------------------------------------- Filter projects Navbar ------------------------------------------------------
export const ROUTES_WITH_PROJECT = [
  `/auth-callback`,
  `/${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.Templates}/${RoutesShortWandP.TemplatesDetail}/:`,
  `/${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.Templates}/${RoutesShortWandP.TemplatesProjectCollections}`,
  `/${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.LiveReports}`,
  `/${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.Inspections}`,
  `/${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.Inspections}/${RoutesShortWandP.Detail}/:`,
  `/${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.Inspections}/${RoutesShortWandP.Detail}/${RoutesShortWandP.New}`,
  `/${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.Punches}`,
  `/${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.UsersSetup}`,
  `/${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.Maps}`,
  `/${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.Reports}`,
  `/${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.Reports}/${RoutesShortWandP.Detail}/:`,
  `/${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.Common}/${RoutesShortWandP.Downloads}`,
  `/${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.SignedPunches}`,
  // `/${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.ProjectSetup}/${RoutesShortWandP.ProjectOverview}`, // 38699
  `/${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.ProjectSetup}/${RoutesShortWandP.ProjectSettings}`, // 38699
  `/${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.ProjectSetup}/${RoutesShortWandP.WbsTree}`, // 38699
  `/${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.Common}/${RoutesShortWandP.ProjectProcess}`, // 38699
  `/${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.TemplateConfiguration}/${RoutesShortWandP.TemplateOverview}`, // 38699
  `/${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.TemplateConfiguration}/${RoutesShortWandP.TemplateSettings}`, // 38699
  `/${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.TemplateConfiguration}/${RoutesShortWandP.InspectionTypes}`, // 38699
  `/${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.TemplateConfiguration}/${RoutesShortWandP.CustomFields}`, // 38699
  // `/${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.Templates}/${RoutesShortWandP.TemplatesGlobalCollections}`, // 38699
  `/${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.Audit}`,
];
export const ROUTES_DISABLED_PROJECT = [
  `/${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.Templates}/${RoutesShortWandP.TemplatesDetail}/:`,
  `/${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.Inspections}/${RoutesShortWandP.Detail}/:`,
  `/${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.Projects}`,
  `/${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.Reports}/${RoutesShortWandP.Detail}/:`,
];
export const ROUTES_RELOAD = [
  `/${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.Templates}/${RoutesShortWandP.TemplatesGlobalCollections}`,
]

// ------------------------------------------------- Filter projects Navbar ------------------------------------------------------
export const ROUTES_WITH_FILTER = [
  // `/${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.Punches}`
];

// ------------------------------------------------- Special layout ------------------------------------------------------
export const ROUTES_FULL_SCREEN = [
  `/${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.Inspections}/${RoutesShortWandP.Detail}/:`,
  `/${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.Punches}`,
  `/${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.Reports}/${RoutesShortWandP.Detail}/:`,
];

export const ROUTES_FULL_SCREEN_2 = [
  `/${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.Reports}/${RoutesShortWandP.Detail}/:`,
];

export const ROUTES_HIDDEN_SIDEBAR = [
  `/${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.Templates}/${RoutesShortWandP.TemplatesGlobal}/:`,
  `/${RoutesShortWandP.RootConfiguration}${RoutesShortWandP.Inspections}/${RoutesShortWandP.Detail}/:`,
];

export function checkProjects(): boolean {
  const projects: any[] = JSON.parse(localStorage.getItem(CTE_PROJECTS));
  return projects.length > 0;
}

export function checkUserGlobalAdmin(): boolean {
  const user = JSON.parse(localStorage.getItem('user-id'));
  return user?.isGlobalAdmin;
}

export function checkUserSuperAdmin(): boolean {
  const user = JSON.parse(localStorage.getItem('user-id'));
  return user?.globalRole === SUPER_ADMIN;
}